import gql from 'gql-tag'
import { BASE_PATIENT_FRAGMENT } from 'fragments/patient.query'
import {
  EpisodeOfCareTypeEnum,
  NON_DELETED_EPISODE_OF_CARE_STATUSES
} from 'fhir/EpisodeofCare/constants'
import { ConsentTypeCode, NON_DELETED_CONSENT_STATUSES } from 'fhir/Consent/constants'
import { BASE_EPISODE_OF_CARE_FRAGMENT } from 'fragments/episodeOfCare.query'
import { BASE_CONSENT_FRAGMENT } from 'fragments/consent.query'
import { createStatusFilter } from 'fhir/utils'

export const GET_PATIENT_DATA = gql`
  query GetPatientData($patientId: ID!) {
    Patient(id: $patientId) {
      ...BasePatient
      EpisodeOfCareList(
        _reference: patient,
        type: "${EpisodeOfCareTypeEnum.CERT_PERIOD_SKILLED_CARE}",
        _filter: "${createStatusFilter(NON_DELETED_EPISODE_OF_CARE_STATUSES)}",
        _sort: "-_lastUpdated",
        _count: 1000
      ) {
        ...BaseEpisodeOfCare
      }
      ConsentList(
        _reference: patient,
        category: "${ConsentTypeCode.CERT_PERIOD},${ConsentTypeCode.AUTHORIZATION}",
        _filter: "${createStatusFilter(NON_DELETED_CONSENT_STATUSES)}",
        _sort: "-_lastUpdated",
        _count: 1000
      ) {
        ...BaseConsent
      }
    }
  }
  ${BASE_PATIENT_FRAGMENT}
  ${BASE_EPISODE_OF_CARE_FRAGMENT}
  ${BASE_CONSENT_FRAGMENT}
`
